import { Compass, Mic, GraduationCap, Sparkles } from "lucide-react";

export const PACKAGES = [
  {
    title: "AI & Business Systems Audit",
    price: "Starting at $297",
    bestFor: "Business owners who need clarity and a roadmap.",
    includes: [
      "60–90 minute strategy session",
      "Business workflow review",
      "AI opportunity review",
      "Tool and software review",
      "Recommended automation plan",
      "Suggested next steps",
    ],
    cta: "Book an Audit",
    featured: false,
  },
  {
    title: "Workflow & Automation Setup",
    price: "Starting at $1,500",
    bestFor: "Business owners ready to organize and automate their operations.",
    includes: [
      "Workflow mapping",
      "SOP support",
      "CRM or dashboard setup",
      "Client intake or follow-up systems",
      "Automation setup recommendations",
    ],
    cta: "Build My Workflow",
    featured: false,
  },
  {
    title: "App Build & AI System Implementation",
    price: "Starting at $3,500",
    bestFor: "Businesses ready for a custom app, portal, dashboard, or AI-powered system.",
    includes: [
      "App strategy",
      "No-code or AI-assisted buildout",
      "Custom dashboard or portal",
      "Workflow integration",
      "Training and handoff support",
    ],
    cta: "Discuss My App",
    featured: true,
  },
  {
    title: "Business Growth & Systems Consulting",
    price: "$500/month or $100/hour (4-hr min)",
    bestFor: "Business owners who need ongoing strategy, support, and accountability.",
    includes: [
      "Business planning",
      "Offer development",
      "Operations consulting",
      "Systems strategy",
      "Growth planning",
    ],
    cta: "Book a Strategy Call",
    featured: false,
  },
  {
    title: "Speaking, Workshops & AI Trainings",
    price: "Starting at $500",
    bestFor: "Churches, nonprofits, conferences, business groups, and community organizations.",
    includes: [
      "Beginner AI training",
      "AI for business owners",
      "AI for ministry and community work",
      "Prompt writing workshops",
      "Productivity and workflow training",
    ],
    cta: "Book a Training",
    featured: false,
  },
];

export const OFFERING_PREVIEWS = [
  {
    slug: "consulting",
    icon: Compass,
    title: "Consulting",
    sentence:
      "Strategic guidance and custom programs for organizations ready to invest in their people and operations.",
    to: "/offerings#consulting",
  },
  {
    slug: "speaking",
    icon: Mic,
    title: "Speaking",
    sentence:
      "Practical, energizing talks that leave audiences with clarity and a next step.",
    to: "/offerings#speaking",
  },
  {
    slug: "training",
    icon: GraduationCap,
    title: "Training",
    sentence:
      "Hands-on training and certification that builds lasting capacity inside your organization.",
    to: "/offerings#training",
  },
  {
    slug: "ai",
    icon: Sparkles,
    title: "AI",
    sentence:
      "Practical AI education that helps leaders and teams work smarter, without the hype.",
    to: "/offerings#ai",
  },
];

export const SIGNATURE_PROGRAMS = [
  {
    name: "The Rules of Money",
    file: "/programs/rules-of-money.pdf",
    description:
      "A 14-rule financial literacy program for adults, delivered in cohorts with a full facilitator guide and our Money Rules software.",
  },
  {
    name: "Grow Within",
    file: "/programs/grow-within.pdf",
    description:
      "A career-advancement pathway that helps employees move into higher-paying roles and make every raise count.",
  },
  {
    name: "Wealth Builders Club",
    file: "/programs/wealth-builders-club.pdf",
    description:
      "An advanced program for growing savings, investing, homeownership, and building generational wealth.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Working with TMG Consulting Group helped me get clarity, structure, and a real plan for my business systems.",
    author: "Service-Based Business Owner",
  },
  {
    quote:
      "They explain complex systems in a way that makes sense and helps you see how to actually use them.",
    author: "Workshop Attendee",
  },
  {
    quote:
      "TMG Consulting Group brings strategy, warmth, and systems together in a way that helps you move forward.",
    author: "Nonprofit Leader",
  },
];

export const FAQS = [
  {
    q: "What does TMG Consulting Group do?",
    a: "We work where leadership, people, and operations meet. Our four offerings are consulting, speaking, training, and AI education.",
  },
  {
    q: "Who do you work with?",
    a: "Employers, health systems, nonprofits, and government entities that want to develop leaders and keep their workforce — and small business owners and entrepreneurs who want clear systems and support to grow without burning out.",
  },
  {
    q: "What is The Rules of Money?",
    a: "A 14-rule financial literacy program for adults, delivered in cohorts with a full facilitator guide and our Money Rules software.",
  },
  {
    q: "What is Grow Within?",
    a: "A career-advancement pathway that helps employees move into higher-paying roles and make every raise count.",
  },
  {
    q: "What is the Wealth Builders Club?",
    a: "An advanced program for growing savings, investing, homeownership, and building generational wealth.",
  },
  {
    q: "How do we bring a program to our organization?",
    a: "Start with a 30-minute discovery call. We'll learn about your goals, answer your questions, and tell you honestly whether we're the right fit.",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/offerings", label: "Offerings" },
  { to: "/contact", label: "Contact" },
];

export const NAV_OFFERINGS_MENU = [
  { to: "/offerings", label: "All Offerings" },
  { to: "/offerings#consulting", label: "Consulting" },
  { to: "/offerings#speaking", label: "Speaking" },
  { to: "/offerings#training", label: "Training" },
  { to: "/offerings#ai", label: "AI" },
];

export const NAV_TOOLS_MENU = [
  { to: "/ai-readiness", label: "AI Readiness Checklist", badge: "Free" },
  { to: "/funding-readiness-worksheet", label: "Funding Readiness Worksheet", badge: "Free" },
];

// Brand photography
export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_tmarieai/artifacts/su018wb5_ChatGPT%20Image%20Jun%202%2C%202026%2C%2003_09_07%20PM%20%284%29.png";

export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_tmarieai/artifacts/hi8lghhz_ChatGPT%20Image%20Jun%202%2C%202026%2C%2003_09_06%20PM%20%282%29.png";

export const CONFIDENT_IMAGE =
  "https://customer-assets.emergentagent.com/job_tmarieai/artifacts/15cjo56d_ChatGPT%20Image%20Jun%202%2C%202026%2C%2003_09_05%20PM%20%281%29.png";

export const TABLET_IMAGE =
  "https://customer-assets.emergentagent.com/job_tmarieai/artifacts/me0af1i6_ChatGPT%20Image%20Jun%202%2C%202026%2C%2003_09_06%20PM%20%283%29.png";

export const ABSTRACT_TECH =
  "https://images.pexels.com/photos/30869731/pexels-photo-30869731.jpeg";

export const WORKSHOP_IMG =
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85";

export const CONSULTING_IMG = CONFIDENT_IMAGE;
